import { FC } from 'react';
import AdminSettingsHandler from '../Components/AdminSettings/AdminSettingsHandler';

export const PageAdminSettings: FC = () => {
    return <AdminSettingsHandler />;
};
